import React from 'react'
import { Link } from 'react-router-dom'
import topnotch_2 from './images/topnotch/topnotch_2'
import angeethi from './images/company/angeethi'
import sanjay_market from './images/company/sanjay_market'
import navkar_traders from './images/company/navkar_traders'
import deep_traders from './images/company/deep_traders'
import metro_wines from './images/company/metro_wines'
import monika_gardens from './images/company/monika_gardens'
import myra_dryfruits from './images/company/myra_dryfruits'
import shreeram from './images/company/shreeram'

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function Testimonials() {
  return <>
   <div
        className="inner-banner"
        style={{backgroundImage:`linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.7)) , 
        url(${topnotch_2})
        `}}
      >
        <img
          src="https://www.spinner-wp.egenslab.com/wp-content/themes/spinner/assets/images/bg/inner-bannerdot.png"
          className="inner-bannerdot"
          alt="image"
        />
        <img
          src="https://www.spinner-wp.egenslab.com/wp-content/themes/spinner/assets/images/bg/inner-bannerwave.png"
          className="inner-bannerwave"
          alt="image"
        />
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center text-center">
            <div className="col-md-12">
              <div className="text-center">
                <span className='text-light'>What Our Clients Say
</span>
                <h2 className="inner-banner-title wow fadeInLeft">Testimonials </h2>
                <ul id="breadcrumb" className="breadcrumb gap-3">
                  <li className="breadcrumb-item">
                    <Link to="/"> Home </Link>
                  </li>
                  <li className="breadcrumb-item active">Testimonials</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*  customer rating*/}
      <section
        class="elementor-section elementor-top-section elementor-element elementor-element-78ea8d4 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="78ea8d4"
        data-element_type="section"
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-69ac0c3"
            data-id="69ac0c3"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-c37c784 elementor-widget elementor-widget-spinner_heading"
                data-id="c37c784"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title2 primary4">
                    {/* <span>-What We Offer-</span> */}
                    <div>
                      {/* <h3>Our Best Solution</h3> */}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-bf1d42c elementor-widget elementor-widget-spinner_services"
                data-id="bf1d42c"
                data-element_type="widget"
                data-widget_type="spinner_services.default"
              >
                <div class="elementor-widget-container">
                  <script></script>

                  <div class="service2-section ">
                    <div class="row justify-content-center g-4">
                      <div class="col-lg-4 col-md-6 col-sm-10">
                        <div
                          class="service-item2 wow fadeInDown"
                          data-wow-duration="1.5s"
                          data-wow-delay="0.2s"
                        >
                          <div class="service21-icon">
                          
                          </div>

                          <div class="service-content">
                            <span>01</span>

                            <h4>
                              <a href="https://www.spinner-wp.egenslab.com/services/website-devolopment/">
                              Aditi Chordiya

                              </a>
                            </h4>
                            <p class="para">
                            They provide very helpful services to boost up your business. Amazing experience and assured result.


                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-10">
                        <div
                          class="service-item2 wow fadeInDown"
                          data-wow-duration="1.5s"
                          data-wow-delay="0.2s"
                        >
                          <div class="service21-icon">
                            
                          </div>

                          <div class="service-content">
                            <span>02</span>

                            <h4>
                              <a href="https://www.spinner-wp.egenslab.com/services/ui-ux-creative-design/">
                              Nikhil Kadi

                              </a>
                            </h4>
                            <p class="para">
                            Best branding agency in Aurangabad as well as all over Maharashtra. If you also want to make your name A brand so visit top notch as soon as possible


                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-10">
                        <div
                          class="service-item2 wow fadeInDown"
                          data-wow-duration="1.5s"
                          data-wow-delay="0.2s"
                        >
                          <div class="service21-icon">
                           
                          </div>

                          <div class="service-content">
                            <span>03</span>

                            <h4>
                              <a href="https://www.spinner-wp.egenslab.com/services/web-security/">
                              Om Pardeshi

                              </a>
                            </h4>
                            <p class="para">
                            Its a way good company… witch provides best advertising and branding facility as well as web designs .  


                            </p>
                          </div>
                        </div>
                      </div>
                     
                      
                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* owl carousel */}
<div className="container mt-5" style={{backgroundColor:`#F1F6F5`}}>
  <div className="row">
<h1 className='text-center text-light mb-5'><strong>Clients We've Helped
</strong></h1>

      <OwlCarousel className='owl-theme mt-3' loop margin={10} nav>
    <div class='item'>
        {/* <h4>1</h4> */}
        <img src={angeethi} alt="angeethi" style={{height:"110px", width:"230px"}} />
    </div>
    <div class='item'>
    <img src={monika_gardens} alt="monika_gardens"   style={{height:"110px", width:"230px"}}/>
    </div>
    <div class='item'>
    <img src={deep_traders} alt="deep_traders"  style={{height:"110px", width:"230px"}}/>
    </div>
    <div class='item'>
    <img src={metro_wines} alt="metro_wines" style={{height:"110px", width:"230px"}} />
    </div>
    <div class='item'>
    <img src={myra_dryfruits} alt="myra_dryfruits" style={{height:"110px", width:"230px"}} />
    </div>
    <div class='item'>
    <img src={shreeram} alt="shreeram" style={{height:"110px", width:"230px"}} />
    </div>
    <div class='item'>
    <img src={sanjay_market} alt="sanjay_market" style={{height:"110px", width:"230px"}} />
    </div>
    <div class='item'>
    <img src={navkar_traders} alt="navkar_traders" style={{height:"110px", width:"230px"}} />
    </div>
   
</OwlCarousel>
</div>
</div>

{/* request a quoate */}
<div className="quote mt-2 text-light text-center" style={{backgroundImage:`linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.7)) , 
        url(${topnotch_2})`}}>
<h1><strong>Request A Quote
</strong></h1>
<div className="row">
<div className="col-md-6 col-sm-6 text-center">
<p className='text-light m-2'>Brand Planners. User Experience Planners. Shopper Planners. Digital Planners. Social media planners. Content Planners. Channel Planners. You-name-it planners. 
</p>
</div>
<div className="col-md-6 col-sm-6">
<div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft "
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <Link to="/contacts" class="eg-btn btn--primary btn--lg">
                     
                     Get a Quote
                    </Link>
                  </div>
                </div>
</div>


</div>
</div>
  </>
}
